import { ProductSource } from '@epicuro-next/state/config-strip-state';
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { addItemsToBasketTracking } from '../actions/basket-tracking.actions';

export const basketTrackingFeatureKey = 'tracking';

export interface TrackingEntity {
  variantId: string;
  productSource: ProductSource;
  mappedProductSource: unknown;
}

export interface State extends EntityState<TrackingEntity> {}

export const selectId = (entity: TrackingEntity) => entity.variantId;

export const adapter = createEntityAdapter({
  selectId,
});

export const initialState = adapter.getInitialState({});

export const reducer = createReducer(
  initialState,
  on(
    addItemsToBasketTracking,
    (state, { addedItems, productSource, mappedProductSource }) => {
      const existingTrackingItems = Object.values(state.entities);
      const addedTrackingItems = addedItems.reduce((items, currentItem) => {
        const currentItemKey = currentItem.productInfo.displayedProductId;
        const existingItem = existingTrackingItems.find(
          (item) => item?.variantId === currentItemKey,
        );
        if (!productSource.details.recommendationPanel && existingItem) {
          items.push(existingItem);
        } else {
          items.push({
            variantId: currentItem.productInfo.displayedProductId,
            productSource,
            mappedProductSource,
          });
        }
        return items;
      }, [] as TrackingEntity[]);
      return adapter.upsertMany(addedTrackingItems, state);
    },
  ),
);
